<template>
    <span :style="'line-height: '+(lineHeight || 22)+'px;text-align: left; background: #fff'">
        <b>{{title}}</b>
        <span v-if="showMore">
            {{words.slice(0, len).join(sep)}}
        </span>
        <span v-else>
            {{text}} <span style="opacity: 0">.</span>
        </span>
        <a-space v-if="showIcon">

            <span  v-if="noIcon" @click="handleChange" :style="'margin-left: 5px; font-size: '+(tipSize || 18)+'px'" class="paper-primary-text">
                <span v-if="showMore">{{moreText}}</span>
                <span v-else>{{lessText}}</span>
            </span>
            <a v-else @click="handleChange" style="margin-left: 5px">
                <DownCircleOutlined v-if="showMore"/>
                <UpCircleOutlined v-else/>
            </a>
        </a-space>


    </span>
</template>

<script>
    import {DownCircleOutlined, UpCircleOutlined} from '@ant-design/icons-vue';

    export default {
        name: "MoreORLess",
        components: {
            DownCircleOutlined, UpCircleOutlined
        },
        props: ['len', 'noTip', 'text', 'title', 'lineHeight', 'moreText', 'lessText', 'noIcon', 'tipSize'],
        data(){
            let {text, len} = this;
            text = text || '';
            let sep = this.title? "": '';
            let words = text.split(sep);
            return {
                words,
                sep,
                showIcon: words.length > len,
                showMore: true,
                tipText: this.moreText || 'Show more',
            }
        },
        watch: {
            text: function(newValue, oldValue){
                if(newValue !== oldValue){
                    this.words = newValue.split(this.sep);
                }
            }
        },
        methods: {

            handleChange(){
                let {showMore} = this;
                this.showMore = !showMore;
                this.tipText = showMore? (this.moreText || 'Show more'): (this.lessText || 'Show less');
            }
        }
    }
</script>

<style scoped>
    .paper-primary-text {
        color: #576B95!important;
    }
</style>
